<template>
  <div class="dashboard">
    <BlockUI v-if="loading" :mensaje="'Cargando datos'"></BlockUI>
    <TituloComponent icono-titulo="fas fa-chart-line" texto-titulo="Estadísticas empleado"></TituloComponent>
    <div class="card mb-3 col-12">
      <div class="card-body">
        <div class="row">
          <div class="widget-wrapper col-lg-6">
            <div class="widget-heading opacity-10">
              <float-label label="Artículo:" clase=" mb-md-0">
                <v-select v-model="articulo" :options="articulos"></v-select>
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-2">
            <div class="widget-heading opacity-10">
              <float-label label="Desde:" clase=" mb-md-0">
                <input type="date" id="desde" class="form-control" v-model="desde">
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-2">
            <div class="widget-heading opacity-10">
              <float-label label="Hasta:" clase="mb-md-0">
                <input type="date" id="hasta" class="form-control" v-model="hasta">
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-2">
            <div class="widget-heading opacity-10">
              <button type="button" @click="getEstadisticas" class="btn btn-block btn-info p-2">Buscar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="recibido && ventas_vendedor.length > 0">
      <div class="row">
        <div class="col-md-6 col-xl-4">
          <div class="card mb-3 widget-content">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total vendido</div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-success">${{total_ventas | numFormat('0,0.00')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="card mb-3 widget-content">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Mas ventas:</div>
                  <div
                    class="widget-heading text-info"
                  >{{ventas_fecha[0].fecha | moment("DD/MM/YYYY")}}</div>
                </div>
                <div class="widget-content-right">
                  <div
                    class="widget-numbers text-info"
                  >${{ventas_fecha[0].total | numFormat('0,0.00')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="card mb-3 widget-content">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Menos ventas:</div>
                  <div
                    class="widget-heading text-danger"
                  >{{ventas_fecha[ventas_fecha.length -1].fecha | moment("DD/MM/YYYY")}}</div>
                </div>
                <div class="widget-content-right">
                  <div
                    class="widget-numbers text-danger"
                  >${{ventas_fecha[ventas_fecha.length -1].total | numFormat('0,0.00')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="mb-3 card">
            <div class="card-header-tab card-header">
              <div class="card-header-title">
                <i class="header-icon fas fa-trophy icon-gradient bg-tempting-azure"></i>
                Objetivos
              </div>
            </div>
            <ul class="list-group list-group-flush w-100">
              <li class="list-group-item" v-for="objetivo in objetivos" :key="objetivo.id">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper row">
                    <div class="widget-content-left col-12">
                      <div class="widget-heading text-primary">
                        <span>{{objetivo.cantidad}}</span> unidades de
                        <span class="text-primary">{{objetivo.descripcion}}</span>
                      </div>
                      <div class="widget-subheading opacity-10 row">
                        <span class="col-12">
                          Desde:
                          <b class="text-info">{{objetivo.desde | moment("DD/MM/YYYY")}}</b> - Hasta:
                          <b class="text-info">{{objetivo.hasta | moment("DD/MM/YYYY")}}</b>
                        </span>
                        <p class="col-12 mb-1">
                          Unidades vendidas:
                          <b class="text-alternate">{{objetivo.realizado}}</b>
                          ({{((objetivo.realizado/objetivo.cantidad)*100)}}% completado)
                        </p>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar progress-bar-animated bg-info progress-bar-striped"
                          role="progressbar"
                          :aria-valuenow="((objetivo.realizado/objetivo.cantidad)*100)"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          :style="'width: '+((objetivo.realizado/objetivo.cantidad)*100)+'%;'"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mb-3 card">
            <div class="card-header-tab card-header">
              <div
                class="card-header-title font-size-lg font-weight-normal"
                style="text-transform:none"
              >
                <i class="header-icon fas fa-users mr-3 text-muted opacity-6"></i>
                Totales por cliente
              </div>
            </div>
            <div class="widget-chart widget-chart2 text-left p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg">
                  <div class="widget-chart-flex">
                    <div
                      class="widget-title text-uppercase text-primary"
                    >{{ventas_cliente[0].nombre}}</div>
                  </div>
                  <div
                    class="widget-numbers text-success"
                  >${{ventas_cliente[0].total | numFormat('0,0.00')}}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <h6
                class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal"
              >Ranking</h6>
              <input type="text" id="buscarCliente" v-model="buscarCliente" placeholder="Buscar.." class="form-control mb-2">
              <div class="scroll-area-md">
                <div class="scrollbar-container">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="(cliente, i) in ventasCliente" :key="i">
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left">
                            <div class="widget-heading">{{i+1}}) {{cliente.nombre}}</div>
                          </div>
                          <div class="widget-content-right">
                            <div class="fsize-1 text-primary">
                              <span
                                class="font-weight-bold"
                              >$ {{cliente.total | numFormat('0,0.00')}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mb-3 card">
            <div class="card-header-tab card-header">
              <div
                class="card-header-title font-size-lg font-weight-normal"
                style="text-transform:none"
              >
                <i class="header-icon fas fa-users mr-3 text-muted opacity-6"></i>
                Totales por vendedor
              </div>
            </div>
            <div class="widget-chart widget-chart2 text-left p-0">
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content widget-chart-content-lg">
                  <div class="widget-chart-flex">
                    <div
                      class="widget-title text-uppercase text-primary"
                    >{{ventas_vendedor[0].nombre}}</div>
                  </div>
                  <div
                    class="widget-numbers text-success"
                  >${{ventas_vendedor[0].total | numFormat('0,0.00')}}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <h6
                class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal"
              >Ranking</h6>
              <input type="text" id="buscarVendedor" v-model="buscarVendedor" placeholder="Buscar.." class="form-control mb-2">
              <div class="scroll-area-md">
                <div class="scrollbar-container">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="(vendedor,i) in ventasVendedor" :key="i" >
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left">
                            <div class="widget-heading">{{i+1}}) {{vendedor.nombre}}</div>
                          </div>
                          <div class="widget-content-right">
                            <div class="text-primary">
                              <span
                                class="font-weight-bold"
                              >$ {{vendedor.total | numFormat('0,0.00')}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="mb-3 card">
            <div class="card-header-tab card-header">
              <div class="card-header-title">
                <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"></i>
                Gráfico de ventas
              </div>
            </div>
            <div class="widget-chart p-0">
              <div id="graficoVentas"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card mb-3 col-12">
      <div class="card-body">
        <div class="row">
          <div class="widget-wrapper col-lg-4">
            <div class="widget-heading opacity-10">
              <span class="text-danger">No hay datos disponibles</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import FloatLabel from "@/components/layouts/FloatLabel";
import "vue-select/dist/vue-select.css";
import axios from "axios";
export default {
  name: "EstadisticasPorArticulo",
  components: {
    TituloComponent,
    // Select2,
    FloatLabel,
    BlockUI,
  },
  data() {
    return {
      ventas_vendedor: [],
      ventas_cliente: [],
      ventas_fecha: [],
      objetivos: [],
      total_ventas: 0,
      recibido: false,
      loading: false,
      desde:null,
      hasta:null,
      articulo:{code:null, label: 'Seleccionar artículo'},
      buscarVendedor : '',
      buscarCliente: '',
      articulos:[]
    };
  },
  mounted() {
    let date = new Date();
    let first_day = new Date(date.getFullYear(), date.getMonth()-1, 1);
    let last_day = new Date(date.getFullYear(), date.getMonth(), 0);
    this.desde = this.$options.filters.moment(first_day, 'YYYY-MM-DD');
    this.hasta = this.$options.filters.moment(last_day, 'YYYY-MM-DD');
    // this.getEstadisticas();
    this.getArticulos();
  },
  computed:{
    ventasVendedor:function(){
        let filtro = [...this.ventas_vendedor];
        if(this.buscarVendedor == ''){
            return filtro;
        }
        return filtro.filter( 
            function(item){
                return item.nombre.includes(this.buscarVendedor.toUpperCase())
                }.bind(this)
            );
    },
    ventasCliente:function(){
        let filtro = [...this.ventas_cliente];
        if(this.buscarCliente == ''){
            return filtro;
        }
        return filtro.filter( 
            function(item){
                return item.nombre.includes(this.buscarCliente.toUpperCase())
                }.bind(this)
            );
    }
  },
  methods: {
    getEstadisticas() {
      this.loading = true;
      let query = {
        desde: this.desde,
        hasta: this.hasta,
        articulo: this.articulo.code
      }
      axios
        .get("/estadisticas/por-articulo", {params:query})
        .then((res) => {
          if (res.data.success) {
            this.ventas_vendedor = res.data.ventas_vendedor;
            this.ventas_cliente = res.data.ventas_cliente;
            this.ventas_fecha = res.data.ventas_fecha;
            this.objetivos = res.data.objetivos;
            this.total_ventas = this.ventas_fecha.reduce(
              (a, b) => a + b.total,
              0
            );
            this.recibido = true;
            if(this.ventas_vendedor.length > 0){
              this.setGrafico();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setGrafico() {
      let fechas = [];
      let totales = [];
      let ventas = [...this.ventas_fecha];
      ventas.sort((a, b) =>
        a.fecha > b.fecha ? 1 : b.fecha > a.fecha ? -1 : 0
      );
      for (let venta of ventas) {
        fechas.push(venta.fecha);
        totales.push(venta.total);
      }
      const sparklinesBigPrimary = {
        chart: {
          height: 265,
          type: "bar",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        colors: ["#007bff"],
        stroke: {
          width: 0,
          colors: ["#fff"],
          curve: "smooth",
        },
        series: [
          {
            name: "Total",
            data: totales,
          },
        ],
        tooltip: {
          y: {
            formatter: function (val) {
              return "$" + this.$options.filters.numFormat(val, "0,0.00");
            }.bind(this),
          },
        },
        fill: {
          opacity: 0.8,
        },
        xaxis: {
          categories: fechas,
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return "$" + this.$options.filters.numFormat(val, "0,0.00");
            }.bind(this),
          },
        },
      };
      window.Apex = {
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },
      };
      setTimeout(() => {
        let grafico = this.$el.querySelector("#graficoVentas");
        new ApexCharts(grafico, sparklinesBigPrimary).render();
      }, 1000);
    },
    getArticulos(){
        axios.get('/articulos')
        .then(res => {
            this.articulos.push(this.articulo)
            for(let articulo of res.data){
                let item = {
                    code : articulo.id,
                    label: `${articulo.codigo}) ${articulo.descripcion}` 
                }
                this.articulos.push(item);
            }
        })
    }
  },
};
</script>
